import { fakeRequest } from '@/utils/request'

export const getQuestionsFromForeground = (id) => {
  return fakeRequest.get(`problem/detail/${id}`)
}
